import { createAction } from '../../utils/helpers';
import * as actionTypes from './types';

export const fetchProfile = createAction(actionTypes.FETCH_PROFILE);
export const fetchProfileSuccess = createAction(actionTypes.FETCH_PROFILE_SUCCESS);
export const fetchTransactions = createAction(actionTypes.FETCH_TRANSACTIONS);
export const fetchTransactionsSuccess = createAction(actionTypes.FETCH_TRANSACTIONS_SUCCESS);

export const updateProfile = createAction(actionTypes.UPDATE_PROFILE);
export const updateProfileSuccess = createAction(actionTypes.UPDATE_PROFILE_SUCCESS);

export const uploadUserProfileImage = createAction(actionTypes.UPLOAD_USER_PROFILE_IMAGE);
export const uploadUserProfileImageSuccess = createAction(
  actionTypes.UPLOAD_USER_PROFILE_IMAGE_SUCCESS
);

export const connectStripe = createAction(actionTypes.CONNECT_STRIPE);
export const connectStripeSuccess = createAction(actionTypes.CONNECT_STRIPE_SUCCESS);

export const fetchAgentsProfiles = createAction(actionTypes.FETCH_AGENTS_PROFILES);
export const fetchAgentsProfilesSuccess = createAction(actionTypes.FETCH_AGENTS_PROFILES_SUCCESS);

export const sendInvitesToGuides = createAction(actionTypes.SEND_GUIDE_INVITES);
export const revokeInvite = createAction(actionTypes.REVOKE_INVITE);

export const fetchActiveTours = createAction(actionTypes.FETCH_ACTIVE_TOURS);
export const fetchActiveToursSuccess = createAction(actionTypes.FETCH_ACTIVE_TOURS_SUCCESS);

export const addToursToProfile = createAction(actionTypes.ADD_TOURS_TO_PROFILE);

export const addTapToTipTour = createAction(actionTypes.ADD_TTT_TOUR);
export const editTapToTipTour = createAction(actionTypes.EDIT_TTT_TOUR);
export const deleteTour = createAction(actionTypes.DELETE_TOUR);

export const fetchReviewsStatistic = createAction(actionTypes.FETCH_REVIEWS_STATISTIC);
export const fetchReviewsStatisticSuccess = createAction(
  actionTypes.FETCH_REVIEWS_STATISTIC_SUCCESS
);

export const fetchTours = createAction(actionTypes.FETCH_TOURS);
export const fetchToursSuccess = createAction(actionTypes.FETCH_TOURS_SUCCESS);

export const multipleAssign = createAction(actionTypes.MULTIPLE_ASSIGN);

export const facedError = createAction(actionTypes.ACTION_ERROR);
